export default [
  {
    path: '/agriculture',
    name: 'AgricultureDashboard',
    component: () => import('@/components/agriculture-dashboard/index.vue'),
    meta: {
      title: '广水市农业供应链数字平台大数据中心',
    },
  },
]
